const sale = {
  finishOrder: "Complete",
  finishedOrder: "Completed",
  unfinishedOrder: "Not completed",
  code: "Terminal customer code",
  name1: "Terminal customer name 1",
  name2: "Terminal customer name 2",
  shortName: "Terminal customer short name",
  country: "Nationality/region",
  address: "Address",
  zipCode: "Postal code",
  email: "Email address",
  contact: "Contact person",
  phone: "Phone",
  fax: "Fax",
  mobile: "Mobile",
  account1: "Bank account 1",
  bank1: "Bank number 1",
  swiftCode1: "Bank code 1",
  account2: "Bank account 2",
  bank2: "Bank number 2",
  swiftCode2: "Bank code 2",
  currency: "Currency",
  saleType: "Sales channel",
  creditLevel: "Credit level",
  creditLine: "Credit limit",
  depositRate: "Deposit ratio (%)",
  tradeTerm: "Trade terms",
  payMethod: "Payment method",
  commissionRate: "Commission ratio",
  org: "Department in charge",
  billingDays: "Account period (days)",
  principal: "Client",
  relatedDocuments:
    "Related information (contract/business license/invoicing information)",
  documents: "Related information",
  affiliates: "Affiliates",
  customerList: "Terminal customer list",
  addCustomer: "Add terminal customer",
  price: "Price",
  shipAddress: "Shipping address",
  shipAddressBook: "Shipping address book",
  addShipAddress: "Add shipping address",
  shipAddressName: "Recipient name",
  plShipAddressName: "Please enter recipient name",
  shipAddressType: "Recipient type",
  defaultAddress: "Default address",
  setDefault: "Set as default address",
  remark: "Remark",
  bySearchShipAddress: "Search by recipient name, address, or phone",
  plPrice: "Please enter the price",
  priceMax: "Maximum value: {{ num }}",
  priceMin: "Minimum value: {{ num }}",
  plProductPrice:
    "Please select a product and search by entering the inventory name and code",
  plCustomer: "Please select terminal customer",
  addPrice: "Add product price",
  customerRequired: "Terminal customer information cannot be empty",
  productRequired: "Product information cannot be empty",
  priceRequired: "Price cannot be empty",
  product: "Product",
  priceDetail: "Price information",
  exitsPrice: "The price of this product already exists",
  productInfo: "Product information",
  orderNumber: "Sales Order No",
  internalNumber: "Internal Order No",
  receivingUnit: "Receiving unit",
  approvalStatus: "Approval status",
  customerContact: "Terminal customer contact",
  receivingContact: "Receiving contact",
  customerContactPhone: "Terminal customer contact phone",
  receivingContactMobile: "Receiving contact mobile",
  orderType: "Sales type",
  plOrderType: "Please select sales type",
  taxRate: "Tax rate (%)",
  quantity: "Quantity",
  materialStatus: "Material complete status",
  productionStatus: "Production status",
  shipmentStatus: "Shipping status",
  receivingStatus: "Terminal customer receiving status",
  paymentStatus: "Receiving status",
  receivingAddress: "Receiving address",
  realPrice: "Real price",
  totalPrice: "Total price",
  revisePrice: "Adjust price",
  actualPrice: "Actual price",
  orderState: "Order status",
  passed: "Passed",
  notApproval: "Pending",
  plInnerNumber: "Please enter the internal order number",
  plReceivingUnit: "Please enter the receiving unit",
  plReceivingContact: "Please enter the receiving contact",
  plReceivingContactMobile:
    "Please enter the mobile phone number of the receiving contact",
  plReceivingAddress: "Please enter the receiving address",
  orderProduct: "Order Product",
  plMfgr: "Please enter the company model",
  plCustomerModel: "Please enter the terminal customer model number",
  plProductName: "Please enter the inventory name",
  plReqDeliDate: "Please select the required delivery time",
  plSmtStartDate: "Please select the expected launch date",
  plPreFinishDate: "Please select the expected completion date",
  plUrgencyLevel: "Please enter the degree of urgency",
  plSpecialReq: "Please enter special requirements",
  plReRemark: "Please enter remarks",
  plQuantity: "Please enter the quantity",
  customerShortName: "Terminal Customer Short Name",
  productCode: "Inventory Code",
  productName: "Product Name",
  productModel: "Product Model",
  productUom: "UOM",
  addOrder: "Add an order",
  orderSearchTip:
    "Search by order number, terminal customer abbreviation, inventory code, terminal customer model, company model, inventory name, product model, terminal customer code, terminal customer name 1, terminal customer name 2",
  innerNumber: "Internal order number",
  customerModel: "Terminal customer model",
  mfgr: "Company model",
  reRemark: "Remarks",
  reqDeliDate: "Delivery request time",
  smtStartDate: "Expected launch date",
  preFinishDate: "Expected completion date",
  urgencyLevel: "Emergency",
  specialReq: "Special requirements",
  orderInfo: "Order information",
  customerInfo: "Terminal customer information",
  proInfo: "Product information",
  reportInfo: "Report data",
  saleTotalQuantity: "Total quantity to be produced",
  outPro: "Delivery",
  inStock: "In-stock",
  dataReportSearch:
    "Search by keywords such as order number, terminal customer information, and inventory information",
  notReportData: "No report data",
  reportSearchTip:
    "Search by order number, terminal customer code, terminal customer abbreviation, inventory code, and inventory name",
  addEdit: "Add/edit production data",
  productionSearchTip:
    "Search by order number, inventory code, inventory name, and keywords related to terminal customer information",
  exitsData: "Data for the day already exists",
  time: "Time",
  updateSuccess: "Modification successful",
  history: "History details",
  plCode: "Please enter terminal customer code",
  plName1: "Please enter terminal customer name 1",
  plName2: "Please enter terminal customer name 2",
  plShortName: "Please enter terminal customer abbreviation",
  plAddress: "Please enter terminal customer address",
  plZipCode: "Please enter terminal customer postal code",
  plEmail: "Please enter terminal customer email address",
  plContact: "Please enter contact person",
  plPhone: "Please enter terminal customer phone number",
  plFax: "Please enter terminal customer fax number",
  plMobile: "Please enter the terminal customer's mobile phone number",
  plBank1: "Please enter the bank account number 1",
  plAccount1: "Please enter the bank account 1",
  plSwiftCode1: "Please enter the bank code 1",
  plBank2: "Please enter the bank account number 2",
  plAccount2: "Please enter the bank account 2",
  plSwiftCode2: "Please enter the bank code 2",
  plSaleTypes: "Please select the sales type",
  plCreditLevels: "Please select the credit level",
  plCreditLine: "Please enter the credit limit",
  plDepositRate: "Please enter the deposit ratio",
  plTradeTerms: "Please select the trade terms",
  plPaymentMethod: "Please select the payment method",
  plDictCommissionRate: "Please enter the commission ratio",
  plAffiliates: "Please enter the affiliated company",
  plBillingDays: "Please enter the billing period",
  plPrincipal: "Please enter the client",
  plTaxRate: "Please enter the tax rate",
  plOrg: "Please select an organization",
  saleTypeAdd: "Add sales type",
  saleTypeDetail: "Sales type details",
  payAdd: "Add payment method",
  payDetail: "Payment method details",
  tradeAdd: "Add trade terms",
  tradeDetail: "Trade terms details",
  codeRequired: "Terminal customer code is required",
  codeExisted: "Terminal customer code already exists",
  prevRequired: "Please add the previous data first",
  bySearchCustomer:
    "Search by terminal customer code, terminal customer name 1, terminal customer name 2, terminal customer abbreviation, address",
  bySearch:
    "Search by inventory code, inventory name, terminal customer code, terminal customer name 1, terminal customer name 2, terminal customer abbreviation, address",
  bySearchPrice: "Search by inventory code, inventory name, and product model",
  infoExisted: "This information already exists",
  customerNotExist:
    "Terminal customer information does not exist or has been deleted",
  estimateDays: "Estimated Delivery Days",
  expiredAt: "Expiration time",
  plEstimateDays: "Please fill in the expected delivery days",
  plExpiredAt: "Please select an expiration time",
  shippingMethod: "Shipping Method",
  plShipping: "Please select shipping method",
  customerType: "Terminal Customer Type",
  plCustomerType: "Please select terminal customer type",
  productNotExisted: "Please select a product",
  orderSuccessProjectError:
    "Order information modification successful, product information modification failed",
  projectSuccessOrderError:
    "Product information modification successful, order information modification failed",
  productPre: "Approval can only be granted after selecting a product",
  innerNumberPre: "Fill in the internal tracking number for approval",
  passError: "Approval not passed",
  passSuccess: "Approved",
  orderList: "Order list",

  taxPrice: "Unit price including tax",
  plTaxPrice: "Please enter the unit price including tax",

  addRequirement: "Add review form",
  requirement: "Requirement list",

  notRequirement: "Requirement list has not been generated yet",
  orderDate: "Order Date",
  selectColumns: "Select export columns",
  editOrder: "Modify Order",
  updateErr: "Order information modification failed",
  exportPI: "Export PI Template",

  aPrice: "Adjusted Price",
  discount: "Discount/Discount",
  sPrice: "Total Sales Price",
  send: "Backup/Gift",
  sendQuantity: "Backup/Gift Quantity",
  sendAPrice: "Backup/Gift Adjusted Price",
  sendDiscount: "Backup/Gift Discount/Discount",
  sendPrice: "Total price of backup/gift",
  orderTotal: "Order total price",
  discountHelp:
    "Maximum discount price cannot exceed sales price (excluding spare parts): {{count}}",

  // Excel导出相关
  quotationSheet: "QUOTATION SHEET",
  to: "TO:",
  mov: "MOV:",
  effectiveDate: "Effective Date:",
  modelNo: "Model #",
  mfgrNo: "MFGR#",
  picture: "Picture",
  descriptionOfProduct: "Description of Product",
  chipSet: "Chip set",
  package: "Package (pcs/ctn)",
  unitPrice: "Unit Price",
  note: "NOTE",
  quotationNote1: "1) Above quotation is based on payment 100% before shipment.",
  quotationNote2: "2) If order value less than 40,000 USD, the price term will be EX-WORK",
  quotationNote3: "3) Quotation validity:  2 WEEKS from Today.",
  quotationNote4: "4) Confirm order by downpayment (deposit)",
  exportFailed: "Export failed:",
  quotationTitle: "QUOTATION",
  contactPerson: "Contact person:",
  officeTel: "Office tel:",
  emailLabel: "E-mail:",
  date: "Date:",
  quotationNumber: "Quotation No.:",
  respectedCustomer: "Dear Customer",
  quotationIntro: "Thank you for your interest in ZIONCOM Vietnam factory. Based on the information you provided and your desire to work directly with us, we are pleased to provide you with our service proposal and related quotation for your reference.",
  no: "NO",
  quotationProductCode: "Part No.",
  quotationProductDesc: "Description",
  quotationUnit: "Unit",
  quotationCurrency: "Currency",
  moqPrice: "MOQ/ Purchase Price (Excl. Tax)",
  attention: "Note:",
  quotationAttention1: "1. Quotation includes: labor cost, solder paste and delivery to VSIP II, Binh Duong Province.",
  quotationAttention2: "2. Quotation excludes: raw materials and VAT.",
  quotationAttention3: "3. Payment terms: Payment must be made within 30 days after monthly settlement.",
  quotationAttention4: "4. Minimum Order Quantity (MOQ): If below MOQ of 1000 pieces, a mold fee of 2,720,000 VND/order will be charged for each order",
  customerConfirmation: "Customer's confirmation",
  zioncomVietnam: "Zioncom (Vietnam) Jsc",
  inquiryTemplate: "Inquiry Template",
  quotationTemplate: "Quotation Template",
  transferOrder: "Order Transfer Information",
  customerPriceTemplate: "Customer Price Template",
  importCustomerPrice: "Import Customer Price",
  swapRes: "Transfer Order Result",
  originSale: "Original Sales Order",
  orderNo: "Order No.",
  prodOrderNo: "Production Order No.",
  oldCode: "Old Material Code",
  prodCode: "Product Code",
  prodName: "Product Name",
  prodMod: "Specification/Model",
  count: "Quantity",
  uom: "UoM",
  batch: "Batch No.",
  origin: "Department",
  productor: "Material Handler",
  confirmer: "Quality Confirmation",
  prodManager: "Production Supervisor",
  warehouseer: "Warehouse Keeper",
  approver: "Reviewer",
  checker: "Approver",
  inboundNo: "Inbound Order No.",
  inboundDate: "Inbound Date",
  warehouse: "Warehouse",
  finishedWarehouse: "Finished Goods Warehouse",
  inboundType: "Inbound Type",
  prodIn: "Finished Product Inbound Order",
  littleTotal: "Subtotal",
  total: "Total",
  saleSwap: "Convert to Sales Order",
  purSwap: "Convert to Purchase Order",
  notApi: "This customer does not have WmsApi configured and cannot perform order transfer!",
  notSale: "The products in this sales order do not meet the conditions for running a demand order and cannot be transferred!",
  purchaseData: "Purchase Data",
  confirmGeneratePurOrder: "Confirm to generate purchase order?",
  notCusPros: "These materials do not exist in the customer's WMS system. Please maintain these material data in the customer's WMS system first.",
  notPurProPrice: "The purchase price information for these materials from this supplier does not exist in the customer's WMS system. Please maintain the relevant purchase price information in the customer's WMS system first.",
  purSucc: "Purchase order generated successfully",
  onlyOneCustomer: "Only sales orders from the same customer are allowed!",
  editOutPl: "Available outbound quantity has been updated. Please modify the outbound quantity.",
  bomCopyTip: "This sales order has a BOM attachment. Do you want to copy the BOM attachment to the new order as well?",
  bomCopyYes: "Copy Sales Order and BOM Attachment",
  bomCopyCancel: "Copy Sales Order Only",
  receiverFax: "Receiver Fax",
  receiverPhone: "Receiver Phone",
  licenseId: "Business Registration Certificate",
  licenseAddress: "Business Registration Address",
  invoiceNumber: "Invoice Number",
  invoiceAddress: "Invoice Mailing Address",
  printDate: "Printed Date",
  printPageNo: "Page",
  domesticSaleOrder: "Domestic Sales Order",
  printSaleNo: "Sales Order No.",
  printCustomerName: "Customer Full Name",
  printUnifiedTitle: "Business Registration Certificate",
  printOrderDate: "Order Date",
  printSendAddress: "Delivery Address",
  printPhone: "Tel",
  printInvoiceNumber: "Invoice No.",
  printInvoiceAddress: "Invoice Address",
  printContact: "Contact",
  printRemark: "Remark",
  printSeq: "No.",
  printProductName: "Product Name",
  printQuantity: "Sales Qty",
  printBQuantity: "Free/Spare Qty",
  printUom: "UOM",
  printPrice: "Unit Price",
  printAmount: "Amount",
  onlyOneSelectip: "Please select one document",
  printSale: "Print Sales Order",
  printTotalQuantity: "Total Quantity",
  printSaleAmount: "Sales Amount (Local)",
  printSaleTax: "Sales Tax (Local)",
  printTotalAmount: "Total Amount (Local)",
  orderPrintLeft: "After signing, please return or fax back to us: {{fax}}. Thank you!!",
  orderPrintRight: "Copy (White) Accounting (Blue) Sign-off (Red) Customer (Yellow)",
  printApprove: "Approved by",
  printWarehouse: "Warehouse",
  printSales: "Sales",
  printMaker: "Prepared by",
  printCustomerSign: "Customer Sign-off",
  toOfficial: "Convert to Official Order",
  toOfficialConfirm: "Convert the {{count}} selected order(s) to official orders?",
  toOfficialSingleConfirm: "Convert to an official order?",
  toOfficialSuccess: "Converted to official orders",
  toOfficialError: "Failed to convert the following orders",
  toOfficialHasRequirement: "The following orders already have a requirement list and cannot be converted to official orders",
};

export default sale;
